import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import Seo from "@/components/seo/Seo";

export default function NotFound() {
    return (
        <>
            <Seo title="Nie znaleziono strony (404)" path="/404" noindex />
            <section className="relative flex min-h-[70vh] items-center overflow-hidden">
                <div className="pointer-events-none absolute -right-40 -top-40 h-96 w-96 rounded-full bg-gr-accent/20 blur-3xl" aria-hidden />
                <div className="container-gr">
                    <p className="font-mono text-8xl font-bold tracking-tighter text-gr-primary dark:text-gr-dprimary sm:text-9xl">404</p>
                    <h1 className="mt-4 text-3xl tracking-tight text-foreground sm:text-4xl">Ta strona uciekła jak deadline na PIT</h1>
                    <p className="mt-4 max-w-xl text-lg text-muted-foreground">
                        Strona mogła zostać przeniesiona lub usunięta. Wróć na stronę główną, aby kontynuować.
                    </p>
                    <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                        <Link to="/" data-testid="notfound-home" className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:brightness-110 active:scale-95">
                            <Home className="h-4 w-4" /> Strona główna
                        </Link>
                        <Link to="/features" data-testid="notfound-features" className="inline-flex items-center justify-center gap-2 rounded-full border border-border px-6 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-secondary active:scale-95">
                            Zobacz funkcje <ArrowRight className="h-4 w-4" />
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}
